const supportedImageFormats = [
  { name: "JPEG", extensions: ["jpg", "jpeg"], mimeType: ["jpeg", "jpg"] },
  { name: "PNG", extensions: ["png"], mimeType: "png" },
  { name: "GIF", extensions: ["gif"], mimeType: "gif" },
  { name: "WEBP", extensions: ["webp"], mimeType: "webp" },
  // Partial Support only: { name: "SVG", extensions: ["svg"], mimeType: "svg+xml" },
  // Partial Support only: { name: "ICO", extensions: ["ico"], mimeType: "vnd.microsoft.icon" },
  // Partial Support only: { name: "BMP", extensions: ["bmp"], mimeType: "bmp" },
]

export const isFileSupported = (file: File): boolean => {
  const mimeType = file.type.split("/").pop()?.toLowerCase()
  const extension = file.name.split(".").pop()?.toLowerCase()
  return supportedImageFormats.some((format) => {
    return format.extensions.includes(extension) || format.mimeType === mimeType
  })
}

export const isMimeTypeSupported = (mimeType: string): boolean => {
  return supportedImageFormats.some((format) => {
    const isMimeTypeArray = Array.isArray(format.mimeType)
    if (isMimeTypeArray) {
      return format.mimeType.includes(mimeType)
    } else {
      return format.mimeType === mimeType
    }
  })
}

/**
 *  Returns default error message for unsupported file. If File is of type heic or heif, it will return a custom message.
 */
export const getErrorMessageHtml = (files: File[]): string => {
  const mimeTypes = files.map((file) => file.type.split("/").pop())
  const extensions = files.map((file) => "." + file.name.split(".").pop())
  const uniqueExtensions = Array.from(new Set(extensions).values())
  if (mimeTypes.includes("heic") || mimeTypes.includes("heif")) {
    return `
     .heic und .heif Dateiformate werden nicht unterstützt. 
     <br> 
     Für iPhone-Nutzer haben wir einen kleinen Tipp: 
     <a style="color: white;text-decoration: underline" href="https://suus.atlassian.net/wiki/spaces/GSD/pages/2005499909/Dateianh+nge+und+Bilder+im+Forum+Digest" target="_blank">Zum Hilfeartikel</a>
    `
  }
  return `
    Du hast versucht Dateien vom Typ ${uniqueExtensions.join(", ")} hochzuladen.
    <br>
    Es werden nur folgende Dateiformate unterstützt: ${supportedImageFormats
      .map((format) => format.extensions.map((ext) => "." + ext).join(", "))
      .join(", ")}
    <br>
    Du kannst die Bilder auch alternativ als Datei anhängen.
  `
}

export const getUnsupportedMessageForAttachmentImageMode = (
  mimeType: string
): string => {
  const _mimeType = mimeType.split("/").pop()
  return `
    Diese Datei hat das Format "${_mimeType}" und kann nur als Datei angezeigt werden.
    Verwende zum Beispiel .jpg, .jpeg oder .png Dateien, um Bilder direkt im Beitrag anzuzeigen.
  `
}
